import React from 'react';

const YhctSchedule = React.lazy(() => import('pages/YhctSchedule/YhctSchedule'));

const yhctScheduleRoute = [
  {
    path: '/yhct-schedule',
    exact: true,
    name: 'Lịch thủ thuật Phục hồi chức năng/Y học cổ truyền',
    function: 'YHCT_SCHEDULE_VIEW',
    component: YhctSchedule,
  },
];

export default yhctScheduleRoute;
